export const ALL_POINTS_RANGES_VALUE = "all";

export type PointsRangeValue = string;

export type PointsRangeItemDefinition = {
  value: PointsRangeValue;
  displayName: string;
};
